import { render, staticRenderFns } from "./multi-statement.vue?vue&type=template&id=2e9e5498&"
import script from "./multi-statement.vue?vue&type=script&lang=js&"
export * from "./multi-statement.vue?vue&type=script&lang=js&"
import style0 from "./multi-statement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports